import { useTranslation } from "react-i18next";
import { People, CardReceive, CardPos, CardSend } from "iconsax-react";
import { formatMoneyKzt } from "@/shared/utils";
import type { Locale } from "@/shared/utils";

interface Props {
  contractorCount: number;
  totalGross: string;
  totalWithheld: string;
  totalNet: string;
  locale: Locale;
}

interface StatCardProps {
  icon: React.ComponentType<{ size: number; color: string }>;
  label: string;
  value: string | number;
}

function StatCard({ icon: Icon, label, value }: StatCardProps) {
  return (
    <div className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-8 aspect-square flex justify-center items-center surface-component-fill content-action-neutral radius-xs shrink-0">
          <Icon size={16} color="currentColor" />
        </div>
        <span className="text-label-md content-base-primary">{label}</span>
      </div>
      <span className="text-display-sm content-base-primary">{value}</span>
    </div>
  );
}

export default function ContractorPayrollDetailStatCards({
  contractorCount,
  totalGross,
  totalWithheld,
  totalNet,
  locale,
}: Props) {
  const { t } = useTranslation("ContractorPayrollPage");

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
      <StatCard icon={People} label={t("detail.stats.contractors")} value={contractorCount} />
      <StatCard icon={CardReceive} label={t("detail.stats.totalGross")} value={formatMoneyKzt(totalGross, locale)} />
      <StatCard icon={CardSend} label={t("detail.stats.totalNet")} value={formatMoneyKzt(totalNet, locale)} />
      <StatCard icon={CardPos} label={t("detail.stats.totalWithheld")} value={formatMoneyKzt(totalWithheld, locale)} />
    </div>
  );
}
